import type { DisciplineCommentsStore } from './interfaces'

export const getters = {
  isLoading: (state: DisciplineCommentsStore): DisciplineCommentsStore['loading'] => state.loading,
  getComments: (state: DisciplineCommentsStore): DisciplineCommentsStore['comments'] => state.comments,
  getNextCursor: (state: DisciplineCommentsStore): DisciplineCommentsStore['nextCursor'] => state.nextCursor,
  hasMore: (state: DisciplineCommentsStore): boolean => !!state.nextCursor,
}
